/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window._ = require("lodash");
window.axios = require("axios");

import Vue from "vue";

import "core-js/stable";

import "bootstrap-vue/dist/bootstrap-vue.css";
require("./bootstrap");
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue);

import 'vue-multiselect/dist/vue-multiselect.min.css';
import Multiselect from 'vue-multiselect';
Vue.component('vue-multiselect', Multiselect);

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton);

import VJsoneditor from 'v-jsoneditor';
Vue.use(VJsoneditor);

import languageBundle from '@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader';
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueRouter from "vue-router";
import { routes } from "./routes";
Vue.use(VueRouter);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Common Utilities
Vue.component('attributes-list', require('./components/attributes/AttributesList.vue').default);
Vue.component('hermes-simple-editor', require('./components/attributes/SimpleEditor.vue').default);
Vue.component('hermes-json-editor', require('./components/attributes/JSONEditor.vue').default);
Vue.component('html-editor-modal', require('./components/modals/HTMLEditorModal.vue').default);
Vue.component('enc-dec-modal', require('./components/modals/EncDecModal.vue').default);
Vue.component('audit-fields', require('./components/commons/AuditFields.vue').default);
Vue.component('common-loading', require('./components/commons/Loading.vue').default);
Vue.component("loading", require("./components/utility/Loading.vue").default);
Vue.component("promise", require("./components/utility/Promise.vue").default);
Vue.component(
  "field-error",
  require("./components/utility/FieldError.vue").default
);

// Modals
Vue.component('confirmation-modal', require('./components/modals/ConfirmationModal.vue').default);
Vue.component('delete-button', require('./components/modals/DeleteButton.vue').default);
Vue.component('message-modal', require('./components/modals/MessageModal.vue').default);
Vue.component('change-status-modal', require('./components/modals/ChangeStatusModal.vue').default);
Vue.component('import-person-modal', require('./components/modals/ImportPersonModal.vue').default);
Vue.component('message-update-modal', require('./components/program/messages/MessageUpdateModal.vue').default);
Vue.component('message-sample-modal', require('./components/program/messages/MessageSampleModal.vue').default);

// Search Components
Vue.component('common-paginator', require('./components/search/Paginator.vue').default);
Vue.component('search-bar', require('./components/search/SearchBar.vue').default);
Vue.component('simple-search', require('./components/search/SimpleSearch.vue').default);
Vue.component('free-text-search', require('./components/search/FreeTextSearch.vue').default);
Vue.component('advanced-search', require('./components/search/AdvancedSearch.vue').default);
Vue.component('search-format-modal', require('./components/modals/SearchFormatModal.vue').default);

// Admin Roles
Vue.component('role-form', require('./components/admin/roles/RoleForm.vue').default);

// Manage Users
Vue.component('user-form', require('./components/admin/users/UserForm.vue').default);

// History
Vue.component('show-history', require('./components/history/ShowHistory.vue').default);

// Actions
Vue.component('action-index', require('./components/program/actions/ActionIndex.vue').default);
Vue.component('action-form', require('./components/program/actions/ActionForm.vue').default);

// Instances
Vue.component('instance-index', require('./components/admin/instances/InstanceIndex.vue').default);
Vue.component('instance-form', require('./components/admin/instances/InstanceForm.vue').default);
Vue.component('select-instance', require('./components/admin/instances/SelectInstance.vue').default);

// Oauths
Vue.component('oauth-index', require('./components/admin/oauths/OauthIndex.vue').default);
Vue.component('oauth-form', require('./components/admin/oauths/OauthForm.vue').default);

// Persons
Vue.component('person-index', require('./components/program/persons/PersonIndex.vue').default);
Vue.component('person-form', require('./components/program/persons/PersonForm.vue').default);

// Pharma Ops
Vue.component('pharmaops-edit', require('./components/program/pharmaops/PharmaopsEdit.vue').default);

// Message Campaigns
Vue.component('scheduler-index', require('./components/program/campaigns/CampaignIndex.vue').default);
Vue.component('scheduler-form', require('./components/program/campaigns/CampaignForm.vue').default);

// Messages
Vue.component('message-index', require('./components/program/messages/MessageIndex.vue').default);
Vue.component('message-form', require('./components/program/messages/MessageForm.vue').default);

Vue.component("groups", require("./components/admin/users/Groups.vue").default);

// Campaign Analytics
Vue.component('campaign-analytics-index', require('./components/program/analytics/AnalyticsSingleProgram.vue').default);

// Analytics
Vue.component('programs-analytics', require('./components/program/analytics/AnalyticsMultiPrograms.vue').default);


// Views
Vue.component(
  "support-request",
  require("./components/support/Request.vue").default
);

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

import Toast from './utility/toast';
Vue.prototype.$toast = new Toast;

Vue.prototype.$routes = route;
window.locale = 'en';

// Pinia
import { createPinia, PiniaVuePlugin } from "pinia";
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

const app = new Vue({
    i18n: new VueI18n({ locale: window.locale, silentTranslationWarn: true, messages: languageBundle }),
    el: "#app",
    pinia,
    router: new VueRouter({ mode: "history", routes }),
});

window.app = app;
